import { memo, ReactNode, useMemo } from 'react';

import { Link } from 'react-resource-router';

import { Account, Repository } from 'src/components/pipelines/models';

import isInIframe from '../utils/isInIframe';
import { getPipelinesPageURL } from '../utils/links';

export type Props = {
  account?: Account;
  repository?: Repository;
  to: string;
  children: ReactNode;
};

const BitbucketLink = ({
  account,
  repository,
  children,
  to,
  ...rest
}: Props) => {
  const href = useMemo(
    () =>
      repository?.path && account?.addonKey
        ? `${getPipelinesPageURL(repository.path, encodeURI(to))}`
        : to,
    [account, repository, to]
  );
  const target = repository?.path && account?.addonKey ? '_parent' : undefined;

  if (isInIframe()) {
    return (
      <a data-testid="bitbucket-link" href={href} target={target} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <Link data-testid="bitbucket-link" to={to}>
      {children}
    </Link>
  );
};

// eslint-disable-next-line import/no-default-export
export default memo(BitbucketLink);
